import { defineAbility } from '@casl/ability'

import { User } from '../../../models'
import { Roles, userHasRole } from '../../../helpers'

export default (user: User) =>
    defineAbility((can) => {
        if (userHasRole(user, Roles.Accounting)) {
            can('View', 'RefundRecord')
            can('Edit', 'RefundRecord')
        }
    })
